import React, { useState } from 'react'
import IconButton from '@mui/material/IconButton'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import SettingsIcon from '@mui/icons-material/Settings'
import CheckIcon from '@mui/icons-material/Check'

export interface SortOption {
  value: string
  label: string
}

interface RecordNavigationSortMenuProps {
  options: SortOption[]
  value: string
  onChange: (value: string) => void
  disabled?: boolean
}

export const RecordNavigationSortMenu: React.FC<RecordNavigationSortMenuProps> = ({
  options,
  value,
  onChange,
  disabled = false
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const open = Boolean(anchorEl)

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (): void => {
    setAnchorEl(null)
  }

  const handleSelect = (newValue: string): void => {
    onChange(newValue)
    handleClose()
  }

  return (
    <>
      <IconButton
        aria-label="Navigation sort options"
        onClick={handleOpen}
        disabled={disabled}
        size="small"
      >
        <SettingsIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{ role: 'menu' }}
      >
        {options.map((option) => {
          const isSelected = option.value === value
          return (
            <MenuItem
              key={option.value}
              selected={isSelected}
              onClick={() => { handleSelect(option.value) }}
              role="menuitemradio"
              aria-checked={isSelected}
            >
              <ListItemIcon>
                {isSelected ? <CheckIcon fontSize="small" /> : null}
              </ListItemIcon>
              <ListItemText>{option.label}</ListItemText>
            </MenuItem>
          )
        })}
      </Menu>
    </>
  )
}
